import FaceIcon from '@mui/icons-material/Face';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, FormControl, FormControlLabel, Grid, Paper, Switch, TextField, Typography } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../app/store';
import TextFieldData from '../../../../../components/formControls/TextFieldData';
import { formatarDataDDMMYYYY, parseDateDDMMYYYY } from '../../../../../utils/formatDate';
import { atualizarLicitacaoApply, atualizarLicitacaoDataFinal, atualizarLicitacaoDataInicial, atualizarLicitacaoSearch } from './licitacaoPublicListFiltroSlice';

export default function LicitacaoPublicListFiltroForm() {
  const dispatch = useDispatch();
  const licitacaoListFiltro = useSelector((state: RootState) => state.licitacaoPublicListFiltro);

  const [expanded, setExpanded] = useState(false);

  const [search, setSearch] = useState<string>('');    

  const debounceTimeout = useRef<NodeJS.Timeout | null>(null);
    useEffect(() => {
      // Limpar o timeout anterior
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
  
      // Configurar o timeout para o debounce
      debounceTimeout.current = setTimeout(() => {        
        dispatch(atualizarLicitacaoSearch(search))
      }, 700); // Tempo de debounce (700ms)
  
      // Limpar o timeout quando o componente for desmontado ou o efeito for reiniciado
      return () => {
        if (debounceTimeout.current) {
          clearTimeout(debounceTimeout.current);
        }
      };
    }, [search]); // Dependência do useEffect: quando o 'search' mudar




  const handleToggleAccordion = () => {
    setExpanded(prev => !prev);
  };

  const handleDataInicial = (data: Date | null) => {
    dispatch(atualizarLicitacaoDataInicial(formatarDataDDMMYYYY(data)));
  };
  const handleDataFinal = (data: Date | null) => {
    dispatch(atualizarLicitacaoDataFinal(formatarDataDDMMYYYY(data)));
  };

  const handleApplyFilter = (event: React.FormEvent) => {
    event.preventDefault();

    let dataInicial = parseDateDDMMYYYY(licitacaoListFiltro.dataInicial);
    let dataFinal = parseDateDDMMYYYY(licitacaoListFiltro.dataFinal);

    if (!dataInicial || dataInicial?.toDateString().toUpperCase() == 'INVALID DATE') {
      enqueueSnackbar('Data Inicial Inválida!', { variant: 'error' });
      return;
    }
    if (!dataFinal || dataFinal?.toDateString().toUpperCase() == 'INVALID DATE') {
      enqueueSnackbar('Data Final Inválida!', { variant: 'error' });
      return;
    }
    if (dataInicial > dataFinal) {
      enqueueSnackbar('Data Inicial maior que a Data Final!', { variant: 'error' });
      return;
    }    
    dispatch(atualizarLicitacaoApply());
  };

  return (
    <Paper>
      <Accordion expanded={expanded} onChange={handleToggleAccordion}>
        <AccordionSummary expandIcon={<FilterAltIcon />} aria-controls="panel1-content" id="panel1-header">
          <Typography color="secondary" variant="body1" gutterBottom>
            Expanda para ter acesso aos filtros de consulta de Licitações
          </Typography>
        </AccordionSummary>

        <AccordionDetails>
          <Box p={2}>
            <Grid container spacing={3}>
              <Grid item xs={12} container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextFieldData label="Data Inicial" value={parseDateDDMMYYYY(licitacaoListFiltro.dataInicial)} onChange={handleDataInicial} disabled={false} readOnly={false} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextFieldData label="Data Final" value={parseDateDDMMYYYY(licitacaoListFiltro.dataFinal)} onChange={handleDataFinal} disabled={false} readOnly={false} />
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label="Descreva um breve texto para pesquisar:"
                    name="search"
                    onChange={e => setSearch(e.target.value)}
                    value={search}
                    size="small"
                    inputProps={{ maxLength: 50 }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={e => {
                      
                      handleApplyFilter(e);
                    }}
                    sx={{ marginBottom: 2 }}
                  >
                    Aplicar Filtro
                  </Button>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Paper>
  );
}
